 export function debounce(func, timeout = 1500) {
    let searchTimerId;
    return (...args) => {
      clearTimeout(searchTimerId);
      searchTimerId = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }